import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { IRawApplicationChild } from 'projects/common/src/app/interfaces/remote-models/raw-application-child';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu-option-group',
  templateUrl: './menu-option-group.component.html',
  styleUrls: ['./menu-option-group.component.scss'],
})
export class MenuOptionGroupComponent implements OnInit, OnDestroy {
  public configurationCollection: IRawApplicationChild[] = [];
  private subscription: Subscription;

  constructor(private readonly menuService: MenuService) {}

  public ngOnInit(): void {
    this.initializeMenuSubscription();
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /**
   * Initializes the menu subscription and processes applications
   */
  private initializeMenuSubscription(): void {
    this.subscription = this.menuService.menuSource.subscribe((applications: IRawApplicationChild[]) => {
      if (this.configurationCollection.length > 0) {
        return;
      }

      this.processApplicationsWithLevels(applications);
      this.configurationCollection = applications;
    });
  }

  /**
   * Processes applications and assigns levels to each item
   * @param applications - Array of applications to process
   */
  private processApplicationsWithLevels(applications: IRawApplicationChild[]): void {
    applications.forEach((application) => {
      application.level = 0;

      if (application.childs?.length > 0) {
        this.processApplications(application, 0);
      }
    });
  }

  /**
   * Recursively processes child applications and assigns levels
   * @param application - Parent application to process
   * @param level - Current level in the hierarchy
   */
  private processApplications(application: IRawApplicationChild, level: number): void {
    application.childs.forEach((child) => {
      child.level = level + 1;

      if (child.childs?.length > 0) {
        this.processApplications(child, child.level);
      }
    });
  }
}
